<template>
    <div class="selectConstructionEnterprise-box">
        <HeaderNav
            header-title="选择施工单位"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <div class="project-list">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >
                <div
                    class="project-item"
                    v-for="(item, index) in constructionList"
                    :key="index+item.ecid"
                    @click="chosedData(item)"
                >
                    <ul>
                        <li>
                            <span class="icon icon1"></span>
                            <span>企业名称：{{ item.enterprise_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">企业类型：{{ item.enterprise_type_name }}</span>
                        </li>
                        <li>
                            <span class="icon icon3"></span>
                            <span class="info">统一社会信用码：{{ item.construction_uscc }}</span>
                        </li>
                        <li>
                            <span class="icon icon2"></span>
                            <span class="info">成立时间：{{ item.created }}</span>
                        </li>
                    </ul>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            pagetion: {
                pageindex: 0,
                pageSize: 4,
            },
            constructionList: [],
            formData: {},
            loading: false,
            finished: false,
            total: true,
            keywords: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 数据分页加载
        onLoad() {
            this.pagetion.pageindex++;
            this.getPage();
        },
        getPage() {
            const queryStr = '?contract_version_id=' + this.formData.contract_version + '&pageindex='
            + this.pagetion.pageindex + '&pageSize=' + this.pagetion.pageSize;
            this.$axios
                .get('/interfaceApi/sale/contract_manager/construction/list' + queryStr)
                .then(res => {
                    this.loading = false;
                    if (res.total) {
                        this.constructionList = this.constructionList.concat(res.rows);
                        if (this.constructionList.length >= res.total) {
                            this.finished = true;
                        }
                    } else {
                        this.constructionList = [];
                        this.finished = true;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 选中施工单位
        async chosedData(data) {
            this.$router.isBack = 1;
            this.formData.sgdw_id = data.ecid;
            this.formData.sgdw_code = data.construction_uscc;
            this.formData.sgdw_name = data.enterprise_name;
            this.$router.replace({
                name: 'newMaterialPlan',
                params: {
                    formData: this.formData,
                    type: 'selectConstructionEnterpriseBack',
                },
            });
            this.$router.go(-1);
        },
        // 返回
        handleBack() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newMaterialPlan', params: { formData: this.formData } });
            this.$router.go(-1);
        },
    },
    created() {
        this.formData = this.$route.params.formData;
    },
    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.selectConstructionEnterprise-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .project-list
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        .project-item
            padding 12rpx
            background #fff
            margin 12rpx 12rpx 0 12rpx
            .icon
                width 18rpx
                height 18rpx
                display inline-block
                vertical-align middle
                margin-right 10rpx
                &:before
                    content ' '
                    width 16rpx
                    height 16rpx
                    display inline-block
                    background-repeat no-repeat
                    background-size 100% 100%
                &.icon1
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_3.png)
                &.icon2
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_1.png)
                &.icon3
                    &:before
                        background-image url(./../../../assets/images/icons/icon_gy_8.png)
            .info
                color #666666
                font-size 14rpx
            li
                margin-bottom 10rpx
</style>
